var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-checkbox",class:{ 'big-checkbox--active': _vm.value, 'big-checkbox--disabled': _vm.disabled  },on:{"click":function($event){return _vm.clicked()}}},[(_vm.icon)?_c('span',{staticClass:"icon"},[_vm._v(_vm._s(_vm.icon))]):_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }